import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
 { to: "/", label: "Home" },
 { to: "/access", label: "Access" },
 { to: "/mastermind", label: "Mastermind" },
 { to: "/camp", label: "C.A.M.P." },
];

export default function Navbar() {
 const [open, setOpen] = useState(false);
 const [scrolled, setScrolled] = useState(false);
 const location = useLocation();

 useEffect(() => {
 const onScroll = () => setScrolled(window.scrollY > 10);
 onScroll();
 window.addEventListener("scroll", onScroll);
 return () => window.removeEventListener("scroll", onScroll);
 }, []);

 useEffect(() => {
 setOpen(false);
 }, [location.pathname]);

 return (
 <header
 data-testid="site-navbar"
 className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
 scrolled
 ? "bg-ink-900/90 backdrop-blur-xl border-b border-ink-600"
 : "bg-transparent"
 }`}
 >
 <div className="max-w-7xl mx-auto px-4 md:px-8 h-20 flex items-center justify-end">
 <Link
 to="/"
 data-testid="nav-home-link"
 aria-label="Underground Mix. Home"
 className="sr-only"
 >
 Home
 </Link>

 <nav className="hidden md:flex items-center gap-8">
 {links.map((l) => (
 <NavLink
 key={l.to}
 to={l.to}
 data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
 className={({ isActive }) =>
 `text-sm font-medium uppercase tracking-wider transition-colors ${
 isActive ? "text-amber" : "text-white/70 hover:text-white"
 }`
 }
 >
 {l.label}
 </NavLink>
 ))}
 <a
 href="https://join.underground-mix.com/login"
 target="_blank"
 rel="noopener noreferrer"
 data-testid="nav-login"
 className="text-sm font-medium uppercase tracking-wider text-white/70 hover:text-amber transition-colors"
 >
 Login
 </a>
 <Link
 to="/access"
 data-testid="nav-cta-join"
 className="bg-amber hover:bg-amber-hover text-black font-bold uppercase tracking-wider text-xs px-5 py-3 rounded-sm transition-colors"
 >
 Join Today
 </Link>
 </nav>

 <button
 data-testid="nav-mobile-toggle"
 className="md:hidden p-2 text-white"
 onClick={() => setOpen((v) => !v)}
 aria-label="Toggle menu"
 >
 {open ? <X size={24} /> : <Menu size={24} />}
 </button>
 </div>

 {open && (
 <div
 data-testid="nav-mobile-menu"
 className="md:hidden bg-ink-900 border-t border-ink-600"
 >
 <nav className="flex flex-col px-4 py-4 gap-1">
 {links.map((l) => (
 <NavLink
 key={l.to}
 to={l.to}
 className={({ isActive }) =>
 `px-4 py-3 text-sm uppercase tracking-wider transition-colors ${
 isActive ? "text-amber" : "text-white/70"
 }`
 }
 >
 {l.label}
 </NavLink>
 ))}
 <a
 href="https://join.underground-mix.com/login"
 target="_blank"
 rel="noopener noreferrer"
 className="px-4 py-3 text-sm uppercase tracking-wider text-white/70"
 >
 Login
 </a>
 <Link
 to="/access"
 className="mx-4 mt-2 bg-amber text-black text-center font-bold uppercase tracking-wider text-xs px-5 py-3 rounded-sm"
 >
 Join Today
 </Link>
 </nav>
 </div>
 )}
 </header>
 );
}
